import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthGuardService } from 'src/app/services/auth-guard.service';
import { LoginService } from 'src/app/services/login.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginPasswordFormGroup: FormGroup;
  hide;
  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    public authGuardService: AuthGuardService,
    private userService: UserService,
    private router: Router
  ) { }
  ngOnInit(): void {
    this.validateExsistingLogin();
  }
  createLoginWithPasswordForm() {
    this.loginPasswordFormGroup = this.formBuilder.group({
      email: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }
  onClickLoginPassword(loginPass) {
    this.loginService.loginWithPassword(loginPass.email);
  }
  async onClickLoginGetToken() {
    // no need to pass parameter. Check if loginPasswordFormGroup is valid. If yes call loginGetToken With it.
    if (this.loginPasswordFormGroup.valid) {

      const formValue = {
        ...this.loginPasswordFormGroup.value,
        email: this.loginPasswordFormGroup.value.email.toLowerCase().trim()
      };

      await this.authGuardService.loginGetToken(formValue);
    }
  }

  forgotPassword() {
    const emailControl = this.loginPasswordFormGroup.get('email');
    this.router.navigate(['/forgot-password']);
  }



  onClickGetProjects() {
    this.loginService.getAllProjects();
  }
  onClickGetAuthority() {
    this.loginService.getAuthority();
  }
  async signIn(): Promise<void> {
    await this.authGuardService.signIn();
  }

  validateExsistingLogin() {
    if (localStorage.length <= 1) {
      localStorage.clear();
      this.createLoginWithPasswordForm();
    } else {
      this.userService.getAuthorizationCheck().subscribe(
        (res) => {
          if (res.body == true) {
            this.router.navigate(['/home']);
          }
        },
        (error) => {
          localStorage.clear();
          this.createLoginWithPasswordForm();
        }
      );
    }
  }
}
